/* ===== DEFENSIVE CSS RESET ===== */
/* Reset ALL inheritable CSS properties from host page (Shadow DOM still allows inheritance).
 * Applied to root container only, component styles override via higher specificity. */
.sustain-badge-container {
  /* Typography */
  font-family: var(--sustainability-font-family, "Amazon Ember");
  font-size: medium;
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  line-height: normal;
  letter-spacing: normal;
  word-spacing: normal;
  text-align: left;
  text-indent: 0;
  text-transform: none;
  white-space: normal;
  word-break: normal;
  word-wrap: normal;
  hyphens: manual;

  /* Color */
  color: #0f1111;

  /* Visibility */
  visibility: visible;

  /* Lists */
  list-style: none;
  list-style-type: none;
  list-style-position: outside;
  list-style-image: none;

  /* Other */
  cursor: auto;
  direction: ltr;
  quotes: auto;
}

.sustain-badge:hover {
  text-decoration: underline;
  cursor: pointer;
}

.sustainability-theme-dark .sustain-badge,
.sustainability-theme-dark .sustain-badge * {
  color: #ffffff;
}

.sustain-badge-icon {
  vertical-align: text-bottom;
  padding-right: 0.25em;
}

.sustainability-theme-dark .sustain-badge-icon {
  filter: var(--icon-filter-green);
}

.sustain-badge-text {
  font-family: var(--sustainability-font-family, "Amazon Ember");
}

.sustain-badge-chevron {
  padding-left: 0.35em;
}
